/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Preview_SelectInputs */

const cs_blog_preview_select = /** @type {(inputs: Blog_Preview_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte článek pro náhled.`)
};

const en_blog_preview_select = /** @type {(inputs: Blog_Preview_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select an article to preview it here.`)
};

/**
* | output |
* | --- |
* | "Select an article to preview it here." |
*
* @param {Blog_Preview_SelectInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_preview_select = /** @type {((inputs?: Blog_Preview_SelectInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Preview_SelectInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_preview_select(inputs)
	return cs_blog_preview_select(inputs)
});